(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // hide cookie settings footer menu item if privacy api not loaded
  document.addEventListener('DOMContentLoaded', () => {
    const menuEl = document
      .querySelector('footer')
      ?.querySelector('a[href*="#shopifyReshowConsentBanner"]')
      ?.closest('li');
    if (menuEl && !window.privacyBanner) {
      menuEl.classList.add('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.querySelector('.top-button').classList.remove('visibility-hidden');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.querySelector('.top-button').classList.remove('visibility-hidden');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        document.querySelector('.top-button').classList.add('visibility-hidden');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // audio samples TODO move to separate .js file
  const prodEl = document.querySelector('product-info');
  const samples = prodEl ? parseInt(prodEl.dataset.audio) : 0;
  const wrapper = prodEl?.querySelector('.audio-wrapper');

  if (prodEl && samples > 0 && wrapper) {
    const audioEl = wrapper.querySelector('.audio-sample');
    const elementsToToggle = wrapper.querySelectorAll('.audio-icon');

    // both play and pause svgs are present in DOM; this toggled both .hidden classes to switch their visibility
    function toggleHide() {
      if (elementsToToggle) {
        for (let i = 0; i < elementsToToggle.length; i++) {
          elementsToToggle[i].classList.toggle('hidden');
        }
      }
    }

    // plays and pauses audio depending on audio state, also toggles play/pause graphic
    function playAudio() {
      if (audioEl) {
        toggleHide();
        if (audioEl.paused) {
          audioEl.play();
        } else {
          audioEl.pause();
        }
      }
    }

    // toggles play to pause when playback ends
    if (audioEl) {
      audioEl.addEventListener('ended', (event) => {
        toggleHide();
      });
    }

    // play button listener
    wrapper.querySelector('button')?.addEventListener('click', () => {
      playAudio();
    });

    // loads new audio on variant switch if multiple samples are present
    if (!prodEl.hasAttribute('data-audio-single') && audioEl) {
      function loadAudio() {
        if (!audioEl.paused) {
          toggleHide();
          audioEl.pause();
        }
        audioEl.load();
      }

      const observer = new MutationObserver(loadAudio);
      observer.observe(wrapper, {
        subtree: true,
        childList: true,
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-splide"] && !Shopify.designMode) return;
  try {
    
  const dataEl = document.querySelector('.slideshow-splide');
  if (dataEl && dataEl.dataset.id) {
    let splide = new Splide(`.splide-${dataEl.dataset.id}`);
    // on ready
    splide.on('ready', function () {
      if (splide.root.classList.contains('splide--hidden')) splide.root.classList.remove('splide--hidden');
    });
    // init splide
    splide.mount();

    // theme editor
    if (window.Shopify.designMode) {
      // reinit splide on section changes
      document.addEventListener('shopify:section:load', (event) => {
        if (splide) {
          splide = new Splide(`.splide-${event.detail.sectionId}`);
          // on ready
          splide.on('ready', function () {
            if (splide.root.classList.contains('splide--hidden')) splide.root.classList.remove('splide--hidden');
          });
          // init splide
          splide.mount();
        }
      });

      // change slide and pause autoplay on block select
      document.addEventListener('shopify:block:select', (event) => {
        const index = parseInt(event.target.dataset.index);
        if (typeof index === 'number' && splide) {
          splide.go(index);
          splide.Components.Autoplay.pause();
        }
      });

      // resume autoplay on block deselect
      document.addEventListener('shopify:block:deselect', (event) => {
        if (splide && splide.Components.Autoplay.isPaused()) {
          splide.Components.Autoplay.play();
        }
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
